import {Spec} from 'immutability-helper';
import React, {UpdateSpec} from 'react';

import NoteLinkedAppCanvasComponent from 'notebook/integrations/benchling-apps/NoteLinkedAppCanvasComponent';
import {
  AppCanvasNotePart,
  createEmptyNoteLinkedAppCanvas,
  getNoteLinkedAppCanvasesInNote,
} from 'notebook/integrations/benchling-apps/NoteLinkedAppCanvasUtil';
import MediocrePlugins from 'notebook/mediocre/base-plugin/plugins';
import {Format} from 'notebook/mediocre/formatted-text/FormattersConstants';
import {MediocreSearchResultProps} from 'notebook/mediocre/search/SearchResultProps';
import SelectableNotePart from 'notebook/mediocre/selection/block/SelectableNotePart';
import {EditorPropertiesContext} from 'notebook/notes/core-ui/NoteContext';
import NoteConstants from 'notebook/notes/NoteConstants';
import {NoteEditor, NoteEditorPlugin, NoteEditorProps} from 'notebook/notes/NoteEditorTypes';
import {NotePart} from 'notebook/util/NoteUtilConstants';

const CANVAS_PLUGIN_COMPONENT = {
  ...MediocrePlugins.selectablePluginBase,
  required: [],
  make(
    this: NoteEditor,
    item: AppCanvasNotePart,
    _index: number,
    editorProps: NoteEditorProps,
    _itemProps: object,
    _searchResultProps: MediocreSearchResultProps
  ): JSX.Element {
    const {appInstallationApiId, featureDeveloperDefinedId, canvasApiId, provenanceUuid} = item.item;

    return (
      <SelectableNotePart indentation={item.indentation}>
        <EditorPropertiesContext.Consumer>
          {({isConfig}) => (
            <NoteLinkedAppCanvasComponent
              documentId={editorProps.fileId}
              appInstallationId={appInstallationApiId}
              canvasId={canvasApiId}
              featureDeveloperDefinedId={featureDeveloperDefinedId}
              provenanceUuid={provenanceUuid}
              isLocked={editorProps.locked}
              isConfig={isConfig}
            />
          )}
        </EditorPropertiesContext.Consumer>
      </SelectableNotePart>
    );
  },
};

const NOTE_LINKED_APP_CANVAS_PLUGIN: NoteEditorPlugin = {
  type: NoteConstants.NOTE_LINKED_APP_CANVAS,
  typeClass: 'mediocre-item',
  title: 'App Canvas',
  icon: 'palette',
  component: CANVAS_PLUGIN_COMPONENT,
  linkable: false,
  canPasteFromOtherTenant: false,
  itemToHTML(this: NoteEditor, $el: JQuery, item: AppCanvasNotePart): JQuery {
    $el.attr(NoteConstants.COPY_NOTE_LINKED_OBJECT_DATA_PARENT_ID, this.props.fileId);
    return $el;
  },
  itemFromHTML(this: NoteEditor, $el: JQuery, notepart: AppCanvasNotePart): AppCanvasNotePart | null {
    const sourceFileId = $el.attr(NoteConstants.COPY_NOTE_LINKED_OBJECT_DATA_PARENT_ID);
    if (sourceFileId === this.props.fileId) {
      const existingNotelinkedCanvas = getNoteLinkedAppCanvasesInNote(this.props.note).find(
        (noteLinkedCanvas) => noteLinkedCanvas.provenanceUuid === notepart.item.provenanceUuid
      );
      if (!existingNotelinkedCanvas) {
        return notepart;
      }
    }
    return {
      ...notepart,
      item: createEmptyNoteLinkedAppCanvas(
        notepart.item.appInstallationApiId,
        notepart.item.featureDeveloperDefinedId
      ),
    };
  },
  getContent({code}: {code: string | null}): {code: string | null; blockText: string} {
    throw new Error('Getting content not supported.');
  },
  setContent(props: AppCanvasNotePart): Spec<NotePart> {
    return {$merge: {item: props.item}};
  },
  getText({text, formats}: {text: string; formats: Format}): {text: string; formats: Format} {
    return {text, formats};
  },
  setText({text, formats}: {text: string; formats: Format}): UpdateSpec {
    return {$merge: {text, formats}};
  },
};

export default NOTE_LINKED_APP_CANVAS_PLUGIN;
